<template>
    <section class="offer-slider" v-if="categories.length > 0">
        <div class="container">
            <h1 class="text-center mt-5 mb-3">Product Category</h1>
            <slick ref="slick"
                :options="slickOptions">
                <div class="card-slick" v-for="category in categories">
                    <div class="card-body">
                        <div class="offer-banner text-center">
                            <img :src="appUrl+'/'+category.icon" :alt="category.name" class="img-fluid">
                            <div class="offer-collection">
                                <a :href="appUrl+'/products/'+category.id+'/category'" class="cta-btn">{{ category.name }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </slick>
        </div>
    </section>
</template>
<script>
    import Slick from 'vue-slick';
    export default {
        components: { Slick },
        computed: {},
        data() {
            return {
                categories: [],
                appUrl: document.head.querySelector('meta[name="app-url"]').content,
                slickOptions: {
                    dots: false,
                    infinite: true,
                    speed: 800,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    responsive: [{
                            breakpoint: 1024,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                                infinite: true,
                                dots: true
                            }
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }

                    ]
                },
            };
        },
        mounted() {
            this.getTopCategories();
        },
        methods: {
            getTopCategories() {
                var that = this;
                axios.get('api/get-top-categories')
                .then(function(response) {
                    that.categories = response.data.categories;
                })
                .catch(function (response) {
                    console.log(response);
                    alert('Something went wrong, please try again.');
                });
            },
            next() {
                this.$refs.slick.next();
            },
            prev() {
                this.$refs.slick.prev();
            },
        }
    };
</script>
